import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'

TimeAgo.addDefaultLocale(en)

// used for creating human-readable relative dates (e.g. "3 hours ago", "in 2 days")
const timeAgo = new TimeAgo('en-US')

export {
  timeAgo
}
